// extracted by mini-css-extract-plugin
export var cmlIcon = "styles-module--cmlIcon--f19f5";
export var datachainIcon = "styles-module--datachainIcon--f05e0";
export var dvcIcon = "styles-module--dvcIcon--e1eee";
export var other = "styles-module--other--ff360";
export var studioIcon = "styles-module--studioIcon--13805";
export var vscodeIcon = "styles-module--vscodeIcon--d2e99";